import classNames from 'classnames';

import FolderPaths from '@/utils/images';
import Main from '@layouts/layout-grid/main';
import Text from '@ui/text/text/text';
import styles from './not-found.module.css';
import Link from '@ui/links/link';
import { getLeavePlatformLink } from '@/utils/navigation/get-leave-platform-link';

export default function NotFoundView() {
  const leavePlatformLink = getLeavePlatformLink();
  return (
    <Main>
      <div className={classNames('flex-column jc-center ai-center height-100-vh', styles['not-found'])}>
        <img style={{ height: 264, width: 256 }} src={FolderPaths.TellyTired} alt="Not Found" className="margin-b-16" />
        <section className="flex-column jc-center ai-center margin-b-16 gap-16">
          <Text className="H3">Uh-oh, you've gotten lost</Text>
          <Text className="S1">We can't seem to find the page you're looking for.</Text>
          <div className="margin-t-8">
            <Link
              design="LocalBttnPrim"
              className="L1 padding-v-8 padding-h-12 cursor-pointer"
              to={leavePlatformLink}
              textColor="none"
              borderRadius="4px"
            >
              Back to Homepage
            </Link>
          </div>
        </section>
      </div>
    </Main>
  );
}
